// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ShareButton } from './ShareButton';
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleShare = class ArticleShare extends Vue {
};
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleShare.prototype, "isHidden", void 0);
__decorate([
    Prop({ type: Array, required: true })
], ArticleShare.prototype, "shareButtons", void 0);
ArticleShare = __decorate([
    Component({
        name: 'ArticleShare',
        components: { ShareButton },
        template: `
    <ul class="article-share list-inline d-lg-none" :class="{ '--hidden': isHidden }">
      <li v-for="shareButton in shareButtons" :key="shareButton.label"
          class="article-share-item">
        <ShareButton v-bind="shareButton" />
      </li>
    </ul>
  `
    })
], ArticleShare);
export { ArticleShare };
export default ArticleShare;
